import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "format-h2",
  "use": "format-h2-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"format-h2\"><path fill-rule=\"evenodd\" d=\"M2.5 5h2v6h5V5h2v14h-2v-6h-5v6h-2V5Zm19 12v2h-7v-6a2 2 0 0 1 2-2h3V7h-5c0-1 1-2.045 2-2h2c0-.002.333-.003 1-.003 1 0 2 1.003 2 2.003v4a2 2 0 0 1-2 2h-3v4h5Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol